export function mixHexColors(color1, color2, mixRatio) {
  // Helper function to extract RGBA components from hex color
  function hexToRGBA(hex) {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    const a = hex.length === 9 ? parseInt(hex.slice(7, 9), 16) / 255 : 1;
    return {
      r,
      g,
      b,
      a
    };
  } // Helper function to convert RGBA components back to hex


  function rgbaToHex({
    r,
    g,
    b,
    a
  }) {
    return '#' + [r, g, b, Math.round(a * 255)].map(x => x.toString(16).padStart(2, '0')).join('');
  } // Convert both colors to RGBA


  const rgba1 = hexToRGBA(color1);
  const rgba2 = hexToRGBA(color2); // Calculate the mixed color based on mixRatio

  const r = Math.round(rgba1.r * (1 - mixRatio) + rgba2.r * mixRatio);
  const g = Math.round(rgba1.g * (1 - mixRatio) + rgba2.g * mixRatio);
  const b = Math.round(rgba1.b * (1 - mixRatio) + rgba2.b * mixRatio);
  const a = Math.min(rgba1.a * (1 - mixRatio) + rgba2.a * mixRatio, 1); // Ensure alpha stays within bounds
  // Convert the mixed RGBA back to hex

  return rgbaToHex({
    r,
    g,
    b,
    a
  });
}